
const map = {

    name: "3_1",
    mapType: "surface",
    mapBoundaries: {
        min: {x: 0, y: 4},
        max: {x: 15, y: 14}
    },
    items: [

    ],
    overworld: [
        // blocking side wall?
        {name: "green_bush", coordinates: {x: 15, y: 8}},
        {name: "green_bush", coordinates: {x: 15, y: 9}},
        {name: "green_bush", coordinates: {x: 15, y: 10}},

        // top left wall
        {name: "green_rock_wall_01", coordinates: {x: 0, y: 4}},
        {name: "green_rock_wall_01", coordinates: {x: 1, y: 4}},
        {name: "green_rock_wall_01", coordinates: {x: 0, y: 5}},
        {name: "green_rock_wall_01", coordinates: {x: 1, y: 5}},
        {name: "green_rock_wall_01", coordinates: {x: 0, y: 6}},
        {name: "green_rock_wall_07", coordinates: {x: 1, y: 6}},
        {name: "green_rock_wall_07", coordinates: {x: 0, y: 7}},

        // bottom left wall
        {name: "green_rock_wall_02", coordinates: {x: 0, y: 11}},
        {name: "green_rock_wall_01", coordinates: {x: 0, y: 12}},
        {name: "green_rock_wall_02", coordinates: {x: 1, y: 12}},
        {name: "green_rock_wall_01", coordinates: {x: 0, y: 13}},
        {name: "green_rock_wall_01", coordinates: {x: 1, y: 13}},
        {name: "green_rock_wall_01", coordinates: {x: 0, y: 14}},
        {name: "green_rock_wall_01", coordinates: {x: 1, y: 14}},

        // bush field
        {name: "green_bush", coordinates: {x: 2, y: 4}},
        {name: "green_bush", coordinates: {x: 4, y: 4}},
        {name: "green_bush", coordinates: {x: 6, y: 4}},
        {name: "green_bush", coordinates: {x: 9, y: 4}},
        {name: "green_bush", coordinates: {x: 11, y: 4}},
        {name: "green_bush", coordinates: {x: 13, y: 4}},
        {name: "green_bush", coordinates: {x: 15, y: 4}},
        {name: "green_bush", coordinates: {x: 2, y: 5}},
        {name: "green_bush", coordinates: {x: 4, y: 5}},
        {name: "green_bush", coordinates: {x: 6, y: 5}},
        {name: "green_bush", coordinates: {x: 9, y: 5}},
        {name: "green_bush", coordinates: {x: 11, y: 5}},
        {name: "green_bush", coordinates: {x: 13, y: 5}},
        {name: "green_bush", coordinates: {x: 15, y: 5}},
        {name: "green_bush", coordinates: {x: 15, y: 6}},
        {name: "green_bush", coordinates: {x: 4, y: 7}},
        {name: "green_bush", coordinates: {x: 9, y: 7}},
        {name: "green_bush", coordinates: {x: 13, y: 7}},
        {name: "green_bush", coordinates: {x: 15, y: 7}},
        {name: "green_bush", coordinates: {x: 2, y: 8}},
        {name: "green_bush", coordinates: {x: 4, y: 9}},
        {name: "green_bush", coordinates: {x: 6, y: 9}},
        {name: "green_bush", coordinates: {x: 9, y: 9}},
        {name: "green_bush", coordinates: {x: 11, y: 9}},
        {name: "green_bush", coordinates: {x: 13, y: 9}},

        {name: "green_bush", coordinates: {x: 2, y: 10}},
        {name: "green_bush", coordinates: {x: 4, y: 11}},
        {name: "green_bush", coordinates: {x: 9, y: 11}},
        {name: "green_bush", coordinates: {x: 13, y: 11}},
        {name: "green_bush", coordinates: {x: 15, y: 11}},
        {name: "green_bush", coordinates: {x: 15, y: 12}},
        {name: "green_bush", coordinates: {x: 2, y: 13}},
        {name: "green_bush", coordinates: {x: 4, y: 13}},
        {name: "green_bush", coordinates: {x: 6, y: 13}},
        {name: "green_bush", coordinates: {x: 9, y: 13}},
        {name: "green_bush", coordinates: {x: 11, y: 13}},
        {name: "green_bush", coordinates: {x: 13, y: 13}},
        {name: "green_bush", coordinates: {x: 15, y: 13}},
        {name: "green_bush", coordinates: {x: 2, y: 14}},
        {name: "green_bush", coordinates: {x: 4, y: 14}},
        {name: "green_bush", coordinates: {x: 6, y: 14}},
        {name: "green_bush", coordinates: {x: 9, y: 14}},
        {name: "green_bush", coordinates: {x: 11, y: 14}},
        {name: "green_bush", coordinates: {x: 13, y: 14}},
        {name: "green_bush", coordinates: {x: 15, y: 14}},
    ]
}

export default map
